const arraybufferToResponse = ab => {
  var result = {};
  if (ab != null) {
    // The TextDecoder interface is documented at http://encoding.spec.whatwg.org/#interface-textdecoder
    var dataView = new DataView(ab);
    var decoder = new TextDecoder();
    var decodedString = decoder.decode(dataView);
    result = JSON.parse(decodedString);
  }
  return result;
};
export default arraybufferToResponse;
